import React, { useState, useEffect } from "react";
import axios from "axios";
import GradientButton from '../../../components/GradientButton/GradientButton';
import CancelButton from '../../../components/CancelButton/CancelButton';
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';


const DepartmentsForm = ({ initialData = {}, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    id: "",
    description: "",
    code: "",
    active: true,
    ...initialData,
  });


  const [modal, setModal] = useState({ open: false, type: "error", title: "", message: "" });


  useEffect(() => {
    setFormData((prev) => ({ ...prev, ...initialData }));
  }, [initialData]);

  const closeModal = () => setModal((prev) => ({ ...prev, open: false }));


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("access_token");

      if (initialData && initialData._id) {
        formData.id = initialData._id;
        await axios.put(
          `${process.env.REACT_APP_API_URL}/department/update/${initialData._id}`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/department/create`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("Error en formulario de departamentos:", err);
      const backendMessage =
        err.response?.data?.errors?.[0] ||
        err.response?.data?.message ||
        "Ocurrió un error inesperado. Intenta nuevamente.";

      setModal({
        open: true,
        type: "error",
        title: "Error al guardar",
        message: backendMessage,
      });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="bg-white px-6 py-6 mt-4 rounded-lg shadow-md grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
        <div className="flex flex-col">
          <label htmlFor="code">Código:</label>
          <input
            type="text"
            id="code"
            name="code"
            value={formData.code}
            onChange={handleChange}
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            required
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="description">Descripción:</label>
          <input
            type="text"
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            required
          />
        </div>
        <div className="flex items-center gap-4 mt-2">

          <label htmlFor="active" className="text-gray-600 font-normal">
            Estado:
          </label>

          <button type="button" className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 ${formData.active ? "bg-blue-600" : "bg-gray-300"}`}
            onClick={() =>
              setFormData(prev => ({
                ...prev,
                active: !prev.active
              }))
            }
          >
            <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 ${formData.active ? "translate-x-8" : "translate-x-1"}`} />
          </button>

          <span className="text-sm text-gray-500">
            {formData.active ? "Activo" : "Inactivo"}
          </span>

        </div>
        {/* Botones - ocupan 2 columnas */}
        <div className="flex gap-2 mt-4">
          <GradientButton
            type="submit"
          >
          {initialData._id ? "Guardar" : "Crear"}
          </GradientButton>
          <CancelButton onClick={onCancel} />
        </div>
      </form>
      <ConfirmModal
        isOpen={modal.open}
        title={modal.title}
        message={modal.message}
        type={modal.type}
        confirmText="Aceptar"
        onConfirm={closeModal}
      />
    </>
  );
};

export default DepartmentsForm;
